$(document).ready(function(){
    $('body').on("click", "#add_nomination", function(e){
       e.preventDefault();
       $('.hover_bkgr_fricc').fadeIn();
    });
    $('body').on("click", ".hover_bkgr_fricc, .popup-close-btn", function(e){
       if ($(e.target).hasClass('hover_bkgr_fricc') || $(e.target).hasClass('popup-close-btn')) {
         $('.hover_bkgr_fricc').fadeOut();
       }
    });
    function get_cart(){
      $.get("/cart?view=ajax_side_cart", function(data, status){
               $(".cart-drawer__items").html(data);
               $('.qty-select').removeClass('sm:hidden');
             });
    }
      $('body').on('change', 'input[name="properties[Pack links separately]"]', function(){
                var ID = 39969146798126;
                if ($(this).is(':checked')) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: ID
                  },
                 dataType: 'json',
                 success: function (data) {
                     if($('body').hasClass('template-cart')){
                       window.location.reload();
                     }else{
                       get_cart();
                     }
            }
            });
    
                }else{
              $.ajax({
                   type: 'POST',
                   url: '/cart/change.js',
                   dataType: 'json',
                   data: {
                       quantity: 0,
                       id: ID
                   },
                   success: function (data){
                     if($('body').hasClass('template-cart')){
                       window.location.reload();
                     }else{
                       get_cart();
                     }
                   }
              });
                }
              });
      $('body').on('change', 'input[name="properties[assemble my bracelet for me]"]', function(){
             var ID = 39968325206062;
          if ($(this).is(':checked')) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ID
            },
           dataType: 'json',
           success: function (data) {
               if($('body').hasClass('template-cart')){
                 window.location.reload();
               }else{
                 get_cart();
               }
      }
      });
          }else{
        $.ajax({
             type: 'POST',
             url: '/cart/change.js',
             dataType: 'json',
             data: {
                 quantity: 0,
                 id: ID
             },
             success: function (data){
               if($('body').hasClass('template-cart')){
                 window.location.reload();
               }else{
                get_cart();
               }
             }
        });
          }
        });
      $('body').on('blur', 'input[name="Order of links"]', function(){
          var line = $(this).data('line');
          var vl = $(this).val();
          if (!line) return;
          jQuery.post('/cart/change.js', {
              line: line,
              properties: {
                'Order of links': vl
              }
          });
      });

});

// ==========================================
// NOMINATION CART & CHECKOUT MANAGER
// ==========================================
function showNominationModal() {
  $('quick-buy-modal, .modal, dialog').removeAttr('open');
  document.querySelectorAll('quick-buy-modal[open], dialog[open]').forEach(function(modal) {
    if (typeof modal.close === 'function') {
      try { modal.close(); } catch(err) {}
    }
  });

  $('.hover_bkgr_fricc').css('display', 'flex').hide().fadeIn(200);
}

function hideNominationModal() {
  $('.hover_bkgr_fricc').fadeOut(200);
}

function checkCartForStandaloneBase(forceFetch) {
  var domBases = document.querySelectorAll('.nmbase, [data-is-base="true"]');
  var domLinks = document.querySelectorAll('.nmlink:not(.nmbase), [data-is-link="true"]:not([data-is-base="true"])');

  if (domBases.length > 0 && domLinks.length === 0) {
    showNominationModal();
    return;
  }

  if (forceFetch || window.location.pathname.indexOf('/cart') !== -1) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        var hasBase = false;
        var hasLink = false;

        items.forEach(function(item) {
          var title = (item.title || '').toLowerCase();
          var vendor = (item.vendor || '').toLowerCase();
          var productType = (item.product_type || '').toLowerCase();

          if (title.indexOf('pack links separately') !== -1 || title.indexOf('assemble my bracelet') !== -1) {
            return;
          }

          var isBase = false;
          var isLink = false;

          if (vendor.indexOf('nomination') !== -1 || title.indexOf('nomination') !== -1) {
            if (title.indexOf('base') !== -1 || productType.indexOf('base') !== -1) {
              isBase = true;
            }
            if (title.indexOf('link') !== -1 || productType.indexOf('link') !== -1) {
              if (!isBase) isLink = true;
            }
          } else if (title.indexOf('base bracelet') !== -1 || title.indexOf('nomination base') !== -1) {
            isBase = true;
          }

          if (isBase) hasBase = true;
          if (isLink) hasLink = true;
        });

        if (hasBase && !hasLink) {
          showNominationModal();
        }
      })
      .catch(function() {});
  }
}

function clearCartAndRedirectToIndex() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(function() {
    window.location.href = '/';
  }).catch(function() {
    window.location.href = '/';
  });
}

function proceedToCheckout() {
  window.location.href = '/checkout';
}

function removeBaseBraceletsAndCheckout(itemsToRemove) {
  var updates = {};

  if (Array.isArray(itemsToRemove) && itemsToRemove.length > 0) {
    itemsToRemove.forEach(function(item) {
      if (item.key) {
        updates[item.key] = 0;
      } else if (item.id) {
        updates[item.id] = 0;
      }
    });
  }

  $('.nmbase, [data-is-base="true"], [data-product-id="6812920774702"]').each(function() {
    var $el = $(this);
    var key = $el.data('line-key') || $el.attr('data-line-key');
    if (!key) {
      var $input = $el.find('input.quantity-selector__input, input[name="updates[]"], [data-line-key]');
      key = $input.data('line-key') || $input.attr('name');
    }
    if (key) {
      key = String(key).replace(/^updates\[/, '').replace(/\]$/, '');
      if (key) updates[key] = 0;
    }
  });

  if (Object.keys(updates).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function() {
      window.location.href = '/checkout';
    }).catch(function() {
      window.location.href = '/checkout';
    });
  } else {
    window.location.href = '/checkout';
  }
}

function processNominationCheckout(e) {
  var domBases = document.querySelectorAll('.nmbase, [data-is-base="true"]');
  var domLinks = document.querySelectorAll('.nmlink:not(.nmbase), [data-is-link="true"]:not([data-is-base="true"])');
  var domTargetProducts = document.querySelectorAll('[data-product-id="6812920774702"], [data-variant-id="6812920774702"]');

  if (domBases.length > 0 && domLinks.length === 0) {
    if (e) {
      e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    fetch('/cart.js', { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        var baseItems = [];
        var targetItems = [];
        var linkItems = [];
        var otherItems = [];

        items.forEach(function(item) {
          var title = (item.title || '').toLowerCase();
          var vendor = (item.vendor || '').toLowerCase();
          var productType = (item.product_type || '').toLowerCase();
          var productId = String(item.product_id || '');

          if (title.indexOf('pack links separately') !== -1 || title.indexOf('assemble my bracelet') !== -1) {
            return;
          }

          var isBase = false;
          var isLink = false;
          var isTarget = (productId === '6812920774702');

          if (vendor.indexOf('nomination') !== -1 || title.indexOf('nomination') !== -1) {
            if (title.indexOf('base') !== -1 || productType.indexOf('base') !== -1) {
              isBase = true;
            }
            if (title.indexOf('link') !== -1 || productType.indexOf('link') !== -1) {
              if (!isBase) isLink = true;
            }
          } else if (title.indexOf('base bracelet') !== -1 || title.indexOf('nomination base') !== -1) {
            isBase = true;
          }

          if (!isBase && !isLink && !isTarget) {
            var domEl = document.querySelector('[data-line-key="' + item.key + '"], [data-variant-id="' + item.variant_id + '"]');
            if (domEl) {
              if (domEl.classList.contains('nmbase') || domEl.getAttribute('data-is-base') === 'true') {
                isBase = true;
              } else if (domEl.classList.contains('nmlink') || domEl.getAttribute('data-is-link') === 'true') {
                isLink = true;
              }
            }
          }

          if (isBase) {
            baseItems.push(item);
          } else if (isTarget) {
            targetItems.push(item);
          } else if (isLink) {
            linkItems.push(item);
          } else {
            otherItems.push(item);
          }
        });

        if (baseItems.length > 0 && linkItems.length === 0) {
          showNominationModal();
        } else {
          proceedToCheckout();
        }
      })
      .catch(function() {
        showNominationModal();
      });

    return false;
  }
}

// Global Capture-Phase Event Listeners for 100% guarantee
document.addEventListener('click', function(e) {
  var nominationTrigger = e.target.closest('#add_nomination, .trigger-nomination-modal');
  if (nominationTrigger) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showNominationModal();
    return false;
  }

  var target = e.target.closest('button[name="checkout"], input[name="checkout"], [name="checkout"], a[href="/checkout"], a[href*="/checkout"], .cart__checkout-button, [data-action="checkout"]');
  if (target) {
    processNominationCheckout(e);
  }
}, true);

document.addEventListener('submit', function(e) {
  var form = e.target;
  var action = (form.getAttribute('action') || '').toLowerCase().trim();
  var isAddToCart = (action.indexOf('/cart/add') !== -1);

  if (isAddToCart) {
    // Allow all Add to Cart submissions (PDP & Quick Add) to proceed directly without showing popup
    return;
  }

  // Intercept Checkout form submissions (/cart or /checkout forms)
  var isCheckoutForm = (action.indexOf('/checkout') !== -1) || 
                       (action === '/cart' || action === '/cart/' || (e.submitter && e.submitter.name === 'checkout'));

  if (isCheckoutForm) {
    var domBases = document.querySelectorAll('.nmbase, [data-is-base="true"]');
    var domLinks = document.querySelectorAll('.nmlink:not(.nmbase), [data-is-link="true"]:not([data-is-base="true"])');
    if (domBases.length > 0 && domLinks.length === 0) {
      processNominationCheckout(e);
    }
  }
}, true);

$(document).ready(function () {
  // Open modal on #add_nomination or .trigger-nomination-modal click
  $('body').on('click', '#add_nomination, .trigger-nomination-modal', function(e) {
    e.preventDefault();
    showNominationModal();
  });

  // Close modal on close button or backdrop click
  $('body').on('click', '.hover_bkgr_fricc, .popup-close-btn', function(e) {
    if ($(e.target).hasClass('hover_bkgr_fricc') || $(e.target).hasClass('popup-close-btn')) {
      hideNominationModal();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
    const nmlinkss = document.querySelectorAll('line-item.assemble');
    const nmbasess = document.querySelectorAll('line-item.linkbox');

    // Proceed only if both exist
    if (nmlinkss.length > 0 && nmbasess.length > 0) {
        nmbasess.forEach(nmbase => {
            const removeButton = nmbase.querySelector('.remove-pack-link');
            if (removeButton) {
                removeButton.click();
            }
        });
    }
});


window.addEventListener('scroll', function () {
  if (window.scrollY > 0) {
    document.documentElement.classList.add('scrolled');
  } else {
    document.documentElement.classList.remove('scrolled');
  }
});

//Prevent double initialization globally
if (!window.paginationScriptInitialized) {
  window.paginationScriptInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    const dropdowns = document.querySelectorAll(".custom-pagination-dropdown");
    if (!dropdowns.length) return;

    // ✅ Track if pagination already updated in this session
    if (!window.paginationUpdated) window.paginationUpdated = false;

    // ✅ Initialize dropdown functionality
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector(".dropdown-toggle");
      const menu = dropdown.querySelector(".dropdown-menu");
      const items = dropdown.querySelectorAll(".dropdown-item");
      const currentDisplay = dropdown.querySelector("#currentPaginate");

      // Toggle dropdown visibility
      toggle.addEventListener("click", e => {
        e.stopPropagation();
        menu.classList.toggle("show");
        toggle.classList.toggle("open");
      });

      // Handle item selection
      items.forEach(item => {
        item.addEventListener("click", function () {
          const value = this.dataset.value;
          currentDisplay.textContent = value;
          menu.classList.remove("show");
          toggle.classList.remove("open");

          updatePagination(value);
        });
      });
    });

    // ✅ Close dropdown when clicking outside
    document.addEventListener("click", function () {
      document.querySelectorAll(".dropdown-menu.show").forEach(menu => menu.classList.remove("show"));
      document.querySelectorAll(".dropdown-toggle.open").forEach(btn => btn.classList.remove("open"));
    });

    // ✅ Common function for AJAX update
    function updatePagination(value) {
      if (window.paginationUpdated) return; // prevent double AJAX
      window.paginationUpdated = true;

      const finalValue = value !== "All" ? parseInt(value, 10) : value;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: JSON.stringify({
          attributes: { pagination: finalValue }
        }),
        success: function () {
          console.log("Pagination updated:", finalValue);
          window.location.reload();
        },
        error: function (xhr) {
          console.error("Pagination update failed:", xhr.responseText);
          window.paginationUpdated = false; // allow retry
        }
      });
    }
  });
}


document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.product-gallery__carousel');
  const zoomBtn = document.querySelector('.product-gallery__zoom-button');

  if (carousel && zoomBtn) {
    carousel.addEventListener('click', function() {
      zoomBtn.click();
    });
  }
});


// Listen on document for events that bubble out from shadow DOM
document.addEventListener('change', function(e) {
  const path = e.composedPath();
  const insidePopover = path.some(el => el.tagName === 'X-POPOVER');
  let input = null;
  if (e.target.type === 'radio' && insidePopover) {
    const selectedValue = e.target.value;
    const selectedSize = e.target.nextElementSibling?.textContent?.trim();
   const variantOption =  e.target.closest('.variant-picker__option') || input.getRootNode().host?.closest('.variant-picker__option');
    console.log('Selected Value:', selectedValue);
    console.log('Selected Size:', selectedSize);
   if (variantOption) {
    const button = variantOption.querySelector('button.select span');
    if (button) {
      button.textContent = selectedSize;
    }
  }

    const form = e.target.closest('product-card');
    console.log(form);
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = selectedValue;
        console.log("Updated input[name='id'] value to:", selectedValue);
      }
    }
  }
}, true); 
// document.addEventListener("change", function(e) {
//   let target = e.target;
//   let input = null;

//   if (target.matches('.popover__value-list input[type="radio"]')) {
//     input = target;
//   } else if (target.getRootNode() instanceof ShadowRoot) {
//     const shadowRoot = target.getRootNode();
//     input = shadowRoot.querySelector('.popover__value-list input[type="radio"]:checked');
//   }

//   if (!input) return;

//   const labelEl = input.closest('label');
//   const selectedLabel = labelEl ? labelEl.querySelector('span')?.textContent.trim() : '';
//   const selectedValue = input.value;

//   console.log("Selected Input Value:", selectedValue);
//   console.log("Selected Size:", selectedLabel);

//   const variantOption = input.closest('.variant-picker__option') 
//     || input.getRootNode().host?.closest('.variant-picker__option');

//   if (variantOption) {
//     const button = variantOption.querySelector('button.select span');
//     if (button) {
//       button.textContent = selectedLabel;
//     }
//   }

//   const form = input.closest('form');
//   console.log(form);
//   if (form) {
//     const idInput = form.querySelector('input[name="id"]');
//     if (idInput) {
//       idInput.value = selectedValue;
//       console.log("Updated input[name='id'] value to:", selectedValue);
//     }
//   }
// });



// (function () {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       console.log("called")
      
//       if (cart.items.length === 1) {
//         console.log("cart.items.length", cart.items.length)

//         let item = cart.items[0];
//         console.log("item.sku", item.sku)

//         if (item.sku === '030000-SI-13') {

//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: item.key,
//               quantity: 0
//             })
//           })
//           .then(res => res.json())
//           .then(data => {
//             console.log('Item removed', data);
//             location.reload(); 
//           });

//         }
//       }
//     });
// })();









// v-stack justify-items-center gap-2   nmbase-minus   nmlink-minus 